// Brittfurn AI-visualisering, driver /pages/visualisering.
// Tar produkt (från ?product=handle), rumsfoto (upload), stil → POST /api/composite → resultat.
// Inloggad: "Spara till mitt konto" → POST /api/configurations type='tapet'|'matta'.

import { sized } from '../utils/img.js';

(function () {
  const BACKEND = (document.querySelector('meta[name="bf-backend-url"]') || {}).content
    || 'https://backend-sam-8064s-projects.vercel.app';

  const root = document.querySelector('[data-bf-vis]');
  if (!root) return;

  // Kunden är inloggad (Liquid-gaten släpper bara igenom [data-bf-vis] för customer).
  // Vi skickar med kontouppgifter till rendern så backend kan koppla bilden till kunden.
  const customer = {
    id: root.dataset.customerId || '',
    email: root.dataset.customerEmail || '',
    name: root.dataset.customerName || '',
  };

  const productInfoEl = root.querySelector('[data-bf-vis-product]');
  const fileInput = root.querySelector('[data-bf-vis-file]');
  const previewEl = root.querySelector('[data-bf-vis-preview]');
  const renderBtn = root.querySelector('[data-bf-vis-render]');
  const statusEl = root.querySelector('[data-bf-vis-status]');
  const resultStep = root.querySelector('[data-bf-vis-step="result"]');
  const resultImg = root.querySelector('[data-bf-vis-result]');
  const downloadLink = root.querySelector('[data-bf-vis-download]');
  const saveBtn = root.querySelector('[data-bf-vis-save]');
  const retryBtn = root.querySelector('[data-bf-vis-retry]');

  let state = {
    product: null,           // { id, handle, title, vendor, image, category, price }
    uploadedFile: null,
    style: 'harmony',        // hardcoded, stil-väljare borttagen
    resultUrl: null,
  };

  // ----- Mina sparade, listar favoriter att välja från -----
  const savedRoot = root.querySelector('[data-bf-vis-saved]');
  const savedGrid = root.querySelector('[data-bf-saved-grid]');
  const tabs = root.querySelectorAll('[data-bf-saved-tab]');
  let savedData = { favorites: [] };

  function isTapetOrMatta(item) {
    // Filtrera på handle eller title, om vi inte vet, släpp igenom
    const t = (item.product_title || '').toLowerCase();
    const h = (item.product_handle || '').toLowerCase();
    return /tapet|matta|wallpaper|rug/.test(t + ' ' + h);
  }

  async function loadSaved() {
    try {
      const favs = await fetch(BACKEND + '/api/favorites', { credentials: 'include' })
        .then(r => r.ok ? r.json() : null).catch(() => null);
      if (!favs) return; // inte inloggad, visa inte sektionen

      savedData.favorites = (favs?.favorites || []).filter(f => f.product_handle && isTapetOrMatta(f));

      const total = savedData.favorites.length;
      if (total === 0) return; // inget att visa

      root.querySelector('[data-bf-saved-count-favorites]').textContent = savedData.favorites.length;
      savedRoot.hidden = false;
      renderSavedTab('favorites');
    } catch (e) {
      console.warn('[bf-visualize] loadSaved:', e.message);
    }
  }

  function renderSavedTab(tabName) {
    tabs.forEach(t => t.classList.toggle('is-active', t.getAttribute('data-bf-saved-tab') === tabName));
    const items = savedData.favorites;
    savedGrid.innerHTML = '';
    if (items.length === 0) {
      const empty = document.createElement('p');
      empty.className = 'bf-vis__saved-empty';
      empty.textContent = 'Du har inga favoritmarkerade tapeter eller mattor ännu.';
      savedGrid.appendChild(empty);
      return;
    }
    for (const item of items) {
      const card = document.createElement('button');
      card.type = 'button';
      card.className = 'bf-vis__saved-card';
      if (state.product && state.product.handle === item.product_handle) card.classList.add('is-selected');
      card.innerHTML = `
        <div class="bf-vis__saved-card-cover" style="background-image:url(${sized(item.product_image, 300) || ''})"></div>
        <div class="bf-vis__saved-card-body">
          <p class="bf-vis__saved-card-title">${item.product_title || 'Produkt'}</p>
          <p class="bf-vis__saved-card-vendor">${item.product_vendor || ''}</p>
        </div>
      `;
      card.addEventListener('click', () => {
        loadProduct(item.product_handle);
        // Markera vald
        savedGrid.querySelectorAll('.bf-vis__saved-card').forEach(c => c.classList.remove('is-selected'));
        card.classList.add('is-selected');
      });
      savedGrid.appendChild(card);
    }
  }

  tabs.forEach(t => t.addEventListener('click', () => renderSavedTab(t.getAttribute('data-bf-saved-tab'))));
  loadSaved();

  // ----- Steg 1: ladda vald produkt -----
  const params = new URLSearchParams(location.search);
  const productHandle = params.get('product');
  if (productHandle) loadProduct(productHandle);

  // Resume från sparat projekt?
  const configId = params.get('config');
  if (configId) loadSavedConfig(configId);

  // Förinläst rumsfoto från sessionStorage (från Visualisering-flikens CTA)
  try {
    const pendingImg = sessionStorage.getItem('bf_vis_pending_image');
    const pendingName = sessionStorage.getItem('bf_vis_pending_name') || 'rum.jpg';
    if (pendingImg) {
      sessionStorage.removeItem('bf_vis_pending_image');
      sessionStorage.removeItem('bf_vis_pending_name');
      // Konvertera dataURL → Blob/File
      fetch(pendingImg).then(r => r.blob()).then(blob => {
        const file = new File([blob], pendingName, { type: blob.type });
        state.uploadedFile = file;
        previewEl.src = pendingImg;
        previewEl.hidden = false;
        const prompt = document.querySelector('[data-bf-vis-upload-label] .bf-vis__upload-prompt');
        if (prompt) prompt.style.display = 'none';
        updateRenderButton();
      });
    }
  } catch (err) { /* ignore */ }

  async function loadProduct(handle) {
    try {
      const r = await fetch('/products/' + handle + '.js');
      if (!r.ok) throw new Error('Produkten hittades inte');
      const p = await r.json();
      const category = inferCategory(p);
      state.product = {
        id: p.id, handle: p.handle, title: p.title, vendor: p.vendor,
        image: p.images?.[0] || p.featured_image,
        category, // 'tapet' | 'matta' | 'other'
        price: p.price,
      };
      renderProduct();
      updateRenderButton();
    } catch (e) {
      productInfoEl.innerHTML = `<p style="color:#b22222">Kunde inte ladda produkt: ${e.message}</p>`;
    }
  }

  function inferCategory(p) {
    const t = (p.template_suffix || '').toLowerCase();
    const types = (p.tags || []).map(x => x.toLowerCase()).join(' ');
    if (t.includes('tapet') || /tapet/i.test(types)) return 'tapet';
    if (t.includes('matt') || /matta|matt/i.test(types)) return 'matta';
    return 'other';
  }

  function renderProduct() {
    const p = state.product;
    if (!p) return;
    productInfoEl.innerHTML = `
      <img src="${sized(p.image, 200)}" alt="">
      <div class="meta">
        <h4>${p.title}</h4>
        <p>${p.vendor || ''} · ${p.category === 'tapet' ? 'Tapet' : p.category === 'matta' ? 'Matta' : ''}</p>
      </div>
      <a class="bf-modal__btn" href="/products/${p.handle}">Byt produkt</a>
    `;
  }

  // ----- Steg 2: rumsfoto -----
  fileInput?.addEventListener('change', (e) => {
    const f = e.target.files[0];
    if (!f) return;
    if (f.size > 10 * 1024 * 1024) {
      statusEl.textContent = 'Bilden är för stor (max 10 MB)';
      return;
    }
    state.uploadedFile = f;
    const url = URL.createObjectURL(f);
    previewEl.src = url;
    previewEl.hidden = false;
    document.querySelector('[data-bf-vis-upload-label] .bf-vis__upload-prompt').style.display = 'none';
    updateRenderButton();
  });

  function updateRenderButton() {
    renderBtn.disabled = !(state.product && state.uploadedFile);
  }

  // ----- Steg 3b: rendera via /api/composite -----
  renderBtn?.addEventListener('click', async () => {
    if (!state.product || !state.uploadedFile) return;
    renderBtn.disabled = true;
    statusEl.textContent = 'Renderar... det kan ta 30–60 sekunder';

    try {
      const fd = new FormData();
      fd.append('customer_image', state.uploadedFile);
      fd.append('product_image', state.product.image);
      fd.append('selected_products', JSON.stringify([{
        product_id: state.product.id,
        handle: state.product.handle,
        title: state.product.title,
        vendor: state.product.vendor,
        image: state.product.image,
        category: state.product.category === 'matta' ? 'mattor' : 'tapeter',
      }]));
      fd.append('style', state.style);
      fd.append('consent', 'true');
      // Koppla rendern till den inloggade kunden (för åtkomst + kontaktuppgifter).
      // Skickas som formfält, /api/composite har inte credential-CORS (ingen cookie).
      if (customer.id) fd.append('customer_id', customer.id);
      if (customer.email) fd.append('customer_email', customer.email);
      if (customer.name) fd.append('customer_name', customer.name);

      const r = await fetch(BACKEND + '/api/composite', { method: 'POST', body: fd });
      const data = await r.json();
      if (!r.ok || !data.image_url) {
        throw new Error(data.error || 'Render misslyckades');
      }
      state.resultUrl = data.image_url;
      resultImg.src = data.image_url;
      downloadLink.href = data.image_url;
      resultStep.hidden = false;
      statusEl.textContent = 'Klart ✓';
      resultStep.scrollIntoView({ behavior: 'smooth' });
    } catch (e) {
      statusEl.textContent = 'Fel: ' + e.message;
      renderBtn.disabled = false;
    }
  });

  // ----- Steg 4: spara / försök igen -----
  saveBtn?.addEventListener('click', async () => {
    if (!state.resultUrl) return;
    const title = prompt('Ge projektet ett namn:', state.product.title + ' i mitt rum');
    if (!title) return;
    saveBtn.disabled = true;
    try {
      const r = await fetch(BACKEND + '/api/configurations', {
        method: 'POST', credentials: 'include',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          type: state.product.category === 'matta' ? 'matta' : 'tapet',
          title,
          state_json: { product: state.product, style: state.style },
          preview_url: state.resultUrl,
        }),
      });
      if (!r.ok) {
        const err = await r.json().catch(() => ({}));
        if (r.status === 401) {
          if (confirm('Du måste logga in för att spara. Logga in nu?')) {
            // Nya kundkonton: /customer_authentication/login?return_to=<relativ> tar kunden
            // tillbaka hit. Direktlänk till shopify.com/account ger 406 + tappar return.
            location.href = '/customer_authentication/login?return_to=' + encodeURIComponent(location.pathname + location.search);
          }
          saveBtn.disabled = false;
          return;
        }
        throw new Error(err.error || r.statusText);
      }
      saveBtn.textContent = 'Sparat ✓';
      setTimeout(() => location.href = '/pages/konto?tab=projekt', 1200);
    } catch (e) {
      alert('Kunde inte spara: ' + e.message);
      saveBtn.disabled = false;
    }
  });

  retryBtn?.addEventListener('click', () => location.reload());

  async function loadSavedConfig(id) {
    try {
      const r = await fetch(BACKEND + '/api/configurations/' + id, { credentials: 'include' });
      if (!r.ok) return;
      const { configuration } = await r.json();
      if (configuration.state_json?.product) {
        await loadProduct(configuration.state_json.product.handle);
        if (configuration.state_json.style) {
          state.style = configuration.state_json.style;
          const radio = root.querySelector(`input[value="${state.style}"]`);
          if (radio) radio.checked = true;
        }
      }
      if (configuration.preview_url) {
        resultImg.src = configuration.preview_url;
        downloadLink.href = configuration.preview_url;
        resultStep.hidden = false;
      }
    } catch (e) { console.warn('[bf-visualize]', e); }
  }
})();
